import { AxiosResponse } from "axios";
import { postRequest } from "../commonActions/post";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";
import { deleteRequest } from "../commonActions/delete";
import { patchRequest, putRequest } from "../commonActions/update";

export const CreateSpecialOffers = async ({ payload }: { payload: any }) => {
    try {
      const response: AxiosResponse = await postRequest({
        route: Requests.post.specialOffers,
        payload,
      });
  
      const status = response?.status;
      const message = response?.data?.message;
      const errors = response?.data?.errors;
  
      return {
        status,
        message,
        errors,
      };
    } catch (error) {
      console.error("Error in CreateSpecialOffers:", error);
      throw error;
    }
  };

export const GetSpecialOffers = async ()  => {
    try {
    
      const response: AxiosResponse = await getRequest({
        route: Requests.get.specialOffers,
      });
  
      console.log('myre', response)
  
      const offers = response?.data?.offers;
      const status = response?.data?.success;
      const message = response?.data?.message;
      const errors = response?.data?.message;
  
      return {
        status: status,
        offers,
        errors,
        message: message,
      };
    } catch (error) {
      
      throw error;
    }
  };

  
export const DeleteSpecialOffer = async (query:any)  => {
  console.log('query')
  try {
   
    const response: AxiosResponse = await deleteRequest({
      route: `${Requests.delete.deleteSpecialOffer}/${query}`,
    });
    

    console.log('myre', response)

    const status = response?.data?.success;
    const message = response?.data?.message;
    const errors = response?.data?.message;

    return {
      status: status,
      errors,
      message: message,
    };
  } catch (error) {
  
    throw error;
  }
};


export const GetSpecialOfferById = async (id: string): Promise<any> => {
  try {
   
    const response: AxiosResponse = await getRequest({
      route: `${Requests.get.specialOffers}/${id}`,

    });

    console.log('myre', response)
  
      const offers = response?.data?.specialOffer;
      const status = response?.data?.success;
      const message = response?.data?.message;
      const errors = response?.data?.error;
  

    return {
     offers,
     status,
     message,
     errors,

    };
  } catch (error) {
   
    console.error("Error in Getspeicaloffer:", error);
    throw error;
  }
};

export const UpdateSpecialOffer = async (formData:any, id:any): Promise<any> => {
 
  try {
   
    const response: AxiosResponse = await putRequest({
      route: `${Requests.update.specialOffer}/${id}`,
      payload: formData
    });
    console.log('res', response)
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;
    const success = response?.data?.success
  
    return {
        status,
        message,
        errors,
        success
    };
  } catch (error) {
    
    throw error;
  }
};

export const UpdateSpecialOfferStatus = async (statusData:any, id:any): Promise<any> => {
 
  try {
   
    const response: AxiosResponse = await patchRequest({
      route: `${Requests.update.specialOfferStatus}/${id}`,
      payload: statusData
    });
    console.log('res', response)
    const status = response?.status;
    const message = response?.data?.message;
    const errors = response?.data?.errors;
    const success = response.data.success
  
    return {
        status,
        message,
        errors,
        success
    };
  } catch (error) {
    
    throw error;
  }
};
